import styles from './Loader.module.css'

export default function Header() {
    return (
        <div className={styles.loader}><p>Загрузка</p></div>
    );
}
